import script from "./TopSavingsVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopSavingsVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./TopSavingsVouchersPage.vue?vue&type=style&index=0&id=83a541f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a541f2"]])

export default __exports__